import api from './api';

export interface LoyaltyCustomer {
  id: number;
  tenant_id: number;
  dni: string;
  name?: string | null;
  phone?: string | null;
  points_balance: number;
  points_earned_total: number;
  points_redeemed_total: number;
  created_at: string;
  updated_at?: string | null;
}

export interface LoyaltyTransaction {
  id: number;
  type: string;                 // earn | redeem | adjust | reverse_earn | reverse_redeem
  points: number;               // con signo
  balance_after?: number | null;
  note?: string | null;
  sale_id?: number | null;
  created_at: string;
}

export interface LoyaltyCustomerDetail extends LoyaltyCustomer {
  transactions: LoyaltyTransaction[];
}

export interface LoyaltyConfig {
  min_subtotal_earn: number;    // $ mínimo para sumar
  pesos_per_point: number;      // $ por punto
  redeem_points: number;        // puntos por canje
  redeem_value: number;         // $ de descuento por canje
}

export const loyaltyService = {
  async getConfig(): Promise<LoyaltyConfig> {
    const { data } = await api.get<LoyaltyConfig>('/loyalty/config');
    return data;
  },

  // Busca por DNI exacto (para el checkout). Devuelve null si no existe.
  async lookup(dni: string): Promise<LoyaltyCustomer | null> {
    const { data } = await api.get<LoyaltyCustomer | null>('/loyalty/lookup', { params: { dni } });
    return data ?? null;
  },

  async search(q?: string): Promise<LoyaltyCustomer[]> {
    const { data } = await api.get<LoyaltyCustomer[]>('/loyalty/customers', { params: q ? { q } : undefined });
    return data;
  },

  async getCustomer(id: number): Promise<LoyaltyCustomerDetail> {
    const { data } = await api.get<LoyaltyCustomerDetail>(`/loyalty/customers/${id}`);
    return data;
  },

  async register(payload: { dni: string; name?: string; phone?: string }): Promise<LoyaltyCustomer> {
    const { data } = await api.post<LoyaltyCustomer>('/loyalty/customers', payload);
    return data;
  },

  // Completar/corregir datos del cliente. Solo se manda lo que se edita:
  // mandar el nombre no borra el teléfono ya cargado.
  async update(id: number, payload: { name?: string; phone?: string }): Promise<LoyaltyCustomer> {
    const { data } = await api.patch<LoyaltyCustomer>(`/loyalty/customers/${id}`, payload);
    return data;
  },

  async adjust(id: number, points: number, note?: string): Promise<LoyaltyCustomer> {
    const { data } = await api.post<LoyaltyCustomer>(`/loyalty/customers/${id}/adjust`, { points, note });
    return data;
  },
};
